<script >
/* eslint-disable max-len */
import * as browser from '@futuweb/tool-browser';
import { AI_LINK, AI_SCENE_PUSH_INTEGRATION, Language } from '../assets/conf';
const __sfc_main = {};
__sfc_main.props = ['questionGroup'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    useToast,
    useLang
  } = require('@fegobull/webapi').use;
  const Toast = useToast();
  const emit = __ctx.emit;
  const props = __props;
  const {
    lang
  } = useLang();

  // 从富文本中提取纯文本
  const extractPlainText = htmlText => {
    if (!htmlText) return '';

    // 1. 创建临时 DOM 元素来解析 HTML（最可靠的方法）
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlText;

    // 2. 获取纯文本内容
    let plainText = tempDiv.textContent || tempDiv.innerText || '';

    // 3. 清理多余的空白字符
    plainText = plainText.replace(/\s+/g, ' ') // 多个空白字符替换为单个空格
    .trim(); // 去除首尾空格

    return plainText;
  };
  const handleJump = item => {
    if (browser.isMobileNN()) {
      // 从富文本中提取纯文本：优先使用 questionText，否则从 question 中提取
      const plainText = item.questionText || extractPlainText(item.question);
      const question = stringToHex(plainText);
      const chatUrl = AI_LINK(browser.isMoomoo(), AI_SCENE_PUSH_INTEGRATION, lang, question);
      window.location.href = chatUrl;
    } else {
      const toastText = lang === Language.EN ? 'Please open in the app' : '请在APP中打开';
      Toast.info(toastText);
      emit('jump_download');
    }
  };
  const stringToHex = str => {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(str);
    return Array.from(bytes).map(byte => byte.toString(16).padStart(2, '0')).join('');
  };
  return {
    handleJump
  };
};
export default __sfc_main;
</script>

<template>
    <div class="common-ai-question">
        <div class="main-container">
            <div class="main-content">
                <a class="main-content-item" v-for="item in questionGroup" :key="item.question">
                    <div
                        class="main-content-item-title"
                        :style="{ backgroundImage: `url(${item.background})` }"
                        @click="handleJump(item)"
                    >
                        <div class="main-content-item-title-text" v-html="item.question"></div>
                        <div class="main-content-item-icon">
                            <img src="../images/icon.png" alt="icon" />
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import '../common.less';
</style>
